<div class="modal--container">
  <div class="modal-body">
    <div class="close-button--container">
      <div class="modal-title">{{ titleText() || "Change Request" }}</div>
      <app-mat-icon-button
        buttonStyle="grey"
        iconName="close"
        ariaLabel="Close"
        (buttonClicked)="close()"
      ></app-mat-icon-button>
    </div>
    <div class="grid--container">
      <div class="grid--item">
        <span class="title">Action:</span>
        <span>{{ request()?.requestType }}</span>
      </div>
      @if (request()?.updateDifferences) {
        <div class="grid--item">
          <span class="title">Description:</span>
          <span>{{ request()?.updateDifferences }}</span>
        </div>
      }
      <div class="grid--item">
        <span class="title">Status:</span>
        <span>{{ request()?.requestStatus }}</span>
      </div>
      <div class="grid--item">
        <span class="title">Organisation:</span>
        <span>{{ request()?.organisationName || "-" }}</span>
      </div>
      @if (request()?.laboratoryName) {
        <div class="grid--item">
          <span class="title">Laboratory:</span>
          <span>{{ request()?.laboratoryName }}</span>
        </div>
      }
      @if (request()?.name) {
        <div class="grid--item">
          <span class="title">Name:</span>
          <span>{{ request()?.name }}</span>
        </div>
      }
      @if (request()?.firstName || request()?.lastName) {
        <div class="grid--item">
          <span class="title">User:</span>
          <span>{{ request()?.firstName }} {{ request()?.lastName }}</span>
        </div>
      }
      @if (request()?.userEmail) {
        <div class="grid--item">
          <span class="title">Email:</span>
          <span>{{ request()?.userEmail }}</span>
        </div>
      }
      @if (request()?.superUserFirstName || request()?.superUserLastName) {
        <div class="grid--item">
          <span class="title">Super User:</span>
          <span
            >{{ request()?.superUserFirstName }}
            {{ request()?.superUserLastName }}</span
          >
        </div>
      }
      @if (request()?.superUserEmail) {
        <div class="grid--item">
          <span class="title">Super User Email:</span>
          <span>{{ request()?.superUserEmail }}</span>
        </div>
      }
      @if (request()?.roleId) {
        <div class="grid--item">
          <span class="title">Role:</span>
          <span>{{ RoleEnum[request()?.roleId] | formatRole }}</span>
        </div>
      }
      @if (request()?.licenseType) {
        <div class="grid--item">
          <span class="title">License type:</span>
          <span>{{ request()?.licenseType }}</span>
        </div>
      }
      @if (request()?.userLaboratories) {
        <div class="grid--item">
          <span class="title">Labs:</span>
          <span>{{
            getLabList(request()?.userLaboratories || []) || "-"
          }}</span>
        </div>
      }
      @if (request()?.macAddress) {
        <div class="grid--item">
          <span class="title">Mac Address:</span>
          <span>{{ request()?.macAddress }}</span>
        </div>
      }
      @if (request()?.pumpTubeLength) {
        <div class="grid--item">
          <span class="title">Pump tube length:</span>
          <span>{{ request()?.pumpTubeLength }}</span>
        </div>
      }
      <div class="grid--item">
        <span class="title">Requested On:</span>
        <span>{{ request()?.createdAt | date: "dd/MM/yy, HH:mm a" }}</span>
      </div>
      <div class="grid--item">
        <span class="title">Requested By:</span>
        <span>{{ request()?.requestedBy }}</span>
      </div>
      @if (request()?.actionedBy) {
        <div class="grid--item">
          <span class="title">Actioned On:</span>
          <span>{{ request()?.updatedAt | date: "dd/MM/yy, HH:mm a" }}</span>
        </div>
        <div class="grid--item">
          <span class="title">Actioned By:</span>
          <span>{{ request()?.actionedBy }}</span>
        </div>
      }
      @if (request()?.requestInfo) {
        <div class="grid--item">
          <span class="title">Info:</span>
          <span>{{ request()?.requestInfo }}</span>
        </div>
      }
    </div>
    <div class="button--container">
      <app-button
        buttonStyle="negative"
        [label]="secondaryButtonText()"
        [buttonId]="secondaryButtonId()"
        (buttonClicked)="rejectButtonEventHandler(request()?.id)"
        [isDisabled]="isProcessing() || request()?.requestStatus !== 'Pending'"
      ></app-button>
      <app-button
        buttonStyle="positive"
        [label]="primaryButtonText()"
        [buttonId]="primaryButtonId()"
        (buttonClicked)="approvalButtonEventHandler(request()?.id)"
        [isDisabled]="isProcessing() || request()?.requestStatus !== 'Pending'"
        [isProcessing]="isProcessing()"
      ></app-button>
    </div>
  </div>
  <div class="modal--backdrop"></div>
</div>
